import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { RouterModule } from '@angular/router';
import { ValidarExtratoComponent } from './validar-extrato.component';
import { DialogValidarExtratoComponent } from './dialog-validar-extrato/dialog-validar-extrato.component';


@NgModule({
    declarations: [
        ValidarExtratoComponent,
        DialogValidarExtratoComponent
    ],
    imports: [
        MatTableModule,
        MatSortModule,
        NgxSpinnerModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatRadioModule,
        MatIconModule,
        MatTooltipModule,
        FormsModule,
        CommonModule,
        ReactiveFormsModule,
        NgxMaskDirective,
        NgxMaskPipe,
        MatMenuModule,
        MatDividerModule,
        RouterModule
    ],
    providers: [
        provideNgxMask()
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ValidarExtratoModule {}
